module.exports = __webpack_public_path__ + "media/widget/RevisedGoals-d3f39add.png";